import auth from "./auth";
import common from "./common";
import employee from "./employee";
import quickGuide from "./quickGuide";
import integration from "@/locale/en/integration.ts";
import messages from "@/locale/en/messages.ts";
import home from "@/locale/en/home.ts";
import device from "@/locale/en/device.ts";
import software from "@/locale/en/software.ts";
import settings from "@/locale/en/settings.ts";
import error from "@/locale/en/error.ts";
import securityProfiles from "@/locale/en/securityProfiles";
import configurationProfiles from "@/locale/en/configurationProfiles";
import department from "@/locale/en/department";
import enrollment from "@/locale/en/enrollment";
import security from "@/locale/en/security";
import ticket from "@/locale/en/ticket";

export default {
  auth,
  common,
  employee,
  integration,
  quickGuide,
  settings,
  messages,
  department,
  software,
  device,
  home,
  securityProfiles,
  configurationProfiles,
  error,
  enrollment,
  security,
  ticket,
};
